import React from "react";
import { Form } from "react-bootstrap";
import { _t } from "app/i18n/i18n";

export function OrderByDropdownRedesign({ orderBy, setOrderBy, showOrderByPopularity = true }) {
  const handleChange = (e) => {
    setOrderBy(e.target.value);
  };

  return (
    <Form.Control as="select" size="sm" className="d-inline w-auto mr-2" onChange={handleChange} value={orderBy}>
      <option value="Date_Desc">{_t("Order by date (newest)")}</option>
      <option value="Date_Asc">{_t("Order by date (oldest)")}</option>
      <option value="Pages_Desc">{_t("Order by pages (most)")}</option>
      <option value="Pages_Asc">{_t("Order by pages (fewest)")}</option>
      { showOrderByPopularity && <option value="ReadCount_24h">{_t("Order by popularity (most)")}</option> }
    </Form.Control>
  );
}
